import { useEffect, useState } from "react"
import { ENDPOINTS } from "../../../constants/endpoints"
import useFetch from "../../../hooks/useFetch"

function useFetchPastSessions() {
    const {fetch,loading} = useFetch()

    const [sessions,setSessions] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    useEffect(() => {
        _fetchData(currentPage)
    }, [currentPage])
    
    function _fetchData(page,refetch = false) {
        fetch({endpoint: `${ENDPOINTS.SESSIONS.GET_PAST}?page=${page}`,method:'get'})
        .then(res => {
            setSessions(res?.data)
            if(refetch = true) setPagePast(res.data.page)
        })
    }

    function getPastSessions() {
        return sessions
    }

    function getCurrentPagePast() {
        return currentPage
    }

    function setPagePast(page) {
        setCurrentPage(page)
    }

    function refetchDataPast(page) {
        _fetchData(page,true)
    }

    return {
        getPastSessions,
        getCurrentPagePast,
        refetchDataPast,
        setPagePast,
        loading
    }
}
export default useFetchPastSessions